var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { createRoot } from 'react-dom/client';
import CustomiserBase from './blocks/CustomiserBase';
const selectors = {
    mainProductContainer: '[data-main-product]',
    base: '[data-product-base]',
    mediaWrapper: '[data-product-media]',
    imageWrapper: '[data-product-image]',
    staticProductImage: '[data-static-product-image]',
    customiserProductImage: '[data-customiser-product-image]',
    variantsWrapper: '[data-product-variants]',
    summaryBar: '[data-product-summary-bar]',
    addToCartButtonContainer: '[data-product-info-add-to-cart]',
    customiserTools: '[data-product-info-customiser-tools]',
    thumbnail: '[data-product-thumbnail]',
    mobileShelfToggle: '[data-mobile-shelf-toggle]',
};
// NOTES
// General customisable products use the currentBundle state object
function fetchDataFromUrls(urls) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            // Use Promise.all to fetch data from all URLs simultaneously
            const responses = yield Promise.all(urls.map((url) => fetch(url)));
            // Check if all responses are OK
            responses.forEach((response) => {
                if (!response.ok) {
                    throw new Error(`Failed to fetch data from URL: ${response.url}`);
                }
            });
            // Parse the JSON data from all responses
            const dataPromises = responses.map((response) => response.json());
            const dataArray = yield Promise.all(dataPromises);
            // Combine the data into one array
            const combinedData = dataArray.flat();
            // Return the combined data
            return combinedData;
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    });
}
const initCustomiser = () => __awaiter(void 0, void 0, void 0, function* () {
    const base = document.querySelector(selectors.base);
    const thumbnailContainer = document.querySelector(selectors.thumbnail);
    const variantsWrapper = document.querySelector(selectors.variantsWrapper);
    // Main Product Container
    const mainProductContainer = document.querySelector(selectors.mainProductContainer);
    // Portals
    const mediaWrapper = document.querySelector(selectors.mediaWrapper);
    const staticProductImage = document.querySelector(selectors.staticProductImage);
    const customiserProductImage = document.querySelector(selectors.customiserProductImage);
    const summaryBar = document.querySelector(selectors.summaryBar);
    const customiserTools = document.querySelector(selectors.customiserTools);
    const addToCartButtonContainer = document.querySelector(selectors.addToCartButtonContainer);
    // Mobile Sheld
    const mobileShelfToggle = document.querySelector(selectors.mobileShelfToggle);
    if (mobileShelfToggle && mediaWrapper) {
        mobileShelfToggle.addEventListener('click', () => {
            mediaWrapper.classList.toggle('product__image--small');
        });
    }
    if (base && mediaWrapper && staticProductImage && customiserProductImage && customiserTools && addToCartButtonContainer) {
        const productHandle = base.dataset['productBase'];
        const giftSetProducts = base.dataset['giftSet'];
        const preLoader = document.querySelector('.pre-loader');
        if (giftSetProducts) {
            // GiftSets
            const urls = [`${window.Shopify.routes.root}products/${productHandle}?view=customiser.json`];
            const giftUrls = giftSetProducts.split(',').map((url) => `${window.Shopify.routes.root}products/${url}?view=customiser.json`);
            urls.push(...giftUrls);
            const allGiftSetData = yield fetchDataFromUrls(urls);
            let giftSetData = null;
            if (allGiftSetData) {
                giftSetData = allGiftSetData[0];
                allGiftSetData.shift();
                giftSetData['bundleComponents'] = allGiftSetData.map((innerProd) => {
                    return {
                        components: innerProd.components,
                        default_parts: innerProd.default_parts,
                        product: innerProd.product,
                    };
                });
                giftSetData['product'].has_components = true;
                const root = createRoot(base);
                root.render(React.createElement(CustomiserBase
                // Main Product Container
                , { 
                    // Main Product Container
                    mainProductContainer: mainProductContainer, 
                    // Portals
                    mediaWrapper: mediaWrapper, staticProductImage: staticProductImage, customiserProductImage: customiserProductImage, customiserTools: customiserTools, addToCartButtonContainer: addToCartButtonContainer, 
                    // Misc
                    strings: giftSetData.strings, env: giftSetData.env, settings: giftSetData.settings, bundleComponents: giftSetData.bundleComponents, colourSwatchOrder: giftSetData.colour_swatch_order, addOns: giftSetData.add_ons, baseProduct: giftSetData.product, thumbnailContainer: thumbnailContainer, summaryBar: summaryBar, variantsWrapper: variantsWrapper }));
                if (preLoader) {
                    preLoader.classList.add('pre-loader--hidden');
                }
            }
        }
        else {
            yield fetch(`${window.Shopify.routes.root}products/${productHandle}?view=customiser.json`)
                .then((data) => data.json())
                .then((jsonData) => {
                const productData = jsonData;
                productData['bundleComponents'] = [jsonData].map((innerProd) => {
                    return {
                        components: innerProd.components,
                        default_parts: innerProd.default_parts,
                        product: innerProd.product,
                    };
                });
                const root = createRoot(base);
                return root.render(React.createElement(CustomiserBase
                // Main Product Container
                , { 
                    // Main Product Container
                    mainProductContainer: mainProductContainer, 
                    // Portals
                    mediaWrapper: mediaWrapper, staticProductImage: staticProductImage, customiserProductImage: customiserProductImage, customiserTools: customiserTools, addToCartButtonContainer: addToCartButtonContainer, 
                    // Misc
                    strings: productData.strings, env: productData.env, settings: productData.settings, bundleComponents: productData.bundleComponents, colourSwatchOrder: productData.colour_swatch_order, addOns: productData.add_ons, baseProduct: productData.product, thumbnailContainer: thumbnailContainer, summaryBar: summaryBar, variantsWrapper: variantsWrapper }));
            })
                .then(() => {
                if (preLoader) {
                    preLoader.classList.add('pre-loader--hidden');
                }
            })
                .catch((error) => {
                console.error('Error loading Customiser: Could not fetch product data', error);
            });
        }
    }
});
export default initCustomiser;
